import styled from 'styled-components'

export const MainPage = styled('div')`
  @media (min-width: ${({ theme }) => theme.screen.lgMin}) {
    margin: 20px 0;
    position: relative;
    z-index: 10;
    min-height: 300px;
  }
`

export const PageContent = styled('div')``

export const BreadcrumbContainer = styled('div')`
  padding: 32px 0px 0px;
  background-color: ${({ theme }) => theme.colors.grey4};
  margin-bottom: 0;

  @media (min-width: 1024px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    background: none;
    padding: 0;
  }
`

export const SidebarContainer = styled('div')`
  background-color: ${({ theme }) => theme.colors.grey0};
  border-radius: 8px;
  padding: 1px 16px 16px 16px;
  min-height: 685px;
  overflow: hidden;
  position: relative;
`

export const Container = styled.div`
  @media (min-width: ${({ theme }) => theme.screen.lgMin}) {
    top: 82px;
  }
`

export const ColFiltro = styled('div')`
  padding: 0px 12px;

  @media (min-width: 1200px) {
    flex: 0 0 25%;
    max-width: 25%;
  }

  @media (min-width: 1024px) {
    flex: 0 0 33.333333333333336%;
    max-width: 33.333333333333336%;
  }

  @media (min-width: 320px) {
    flex: 0 0 100%;
    max-width: 100%;
  }
`

export const ColListado = styled('div')`
  padding: 0px 12px;

  @media (min-width: 320px) {
    flex: 0 0 100%;
    max-width: 100%;
    order: 1;
  }

  @media (min-width: 1024px) {
    flex: 0 0 66.66666666666667%;
    max-width: 66.66666666666667%;
    order: 2;
  }

  @media (min-width: 1200px) {
    flex: 0 0 75%;
    max-width: 75%;
    order: 2;
  }
`

export const SortCantidadEmpleosContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${({ facetBanner, isMobile }) => (facetBanner || isMobile ? '0px' : '16px')};
`

export const SpacerMobile = styled.div`
  margin-top: 16px;

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    margin-top: 0;
  }
`

export const FlexContainer = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: center;

  & > i {
    margin-right: 8px;
  }
`

export const CustomTitle = styled.p`
  font-size: 18px;
  line-height: 24px;
  margin: 0;

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    font-size: 24px;
    line-height: 32px;
  }
`
